if (!customElements.get('quick-add-modal')) {
    customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }
      hide(preventFocus = false) {
        this.modalContent = this.modalContent || this.querySelector('[id^="QuickAddInfo-"]');
        const cartNotification = document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
  
        if (preventFocus) this.openedBy = null;
        super.hide();
      }
  
      show(opener) {
        this.modalContent = this.modalContent || this.querySelector('[id^="QuickAddInfo-"]');
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
  
        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
  
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
  
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
  
            //this.removeGalleryListSemantic();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
          });
      }
  
      setInnerHTML(element, html) {
        element.innerHTML = html;
  
        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach(oldScriptTag => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach(attribute => {
            newScriptTag.setAttribute(attribute.name, attribute.value)
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }
  
      preventVariantURLSwitching() {
        this.modalContent = this.modalContent || this.querySelector('[id^="QuickAddInfo-"]');
        const variants = this.modalContent.querySelector('variant-radios');
        if( variants ) variants.setAttribute('data-update-url', 'false');
      }
  
      removeDOMElements() {
        const productModal = this.productElement.querySelector('product-modal');
        const shippingModal = this.productElement.querySelector('[id^="ShippingModal-"]');
        if (productModal) productModal.remove();
        if (shippingModal) shippingModal.remove();
      }
  
      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
        this.productElement.querySelectorAll('variant-radios').forEach((variantSelect) => {
          variantSelect.dataset.originalSection = sectionId;
        });
      }
  
      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
  
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      }
    });
  } 